import classNames from 'classnames';
import Icon from '@/components/atoms/icon/icon';
import Typography from '@/components/atoms/typography/typography';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import ModuleWrapper, {
  ModuleWrapperProps,
} from '@/components/utilities/module-wrapper/module-wrapper';
import Row from '@/components/utilities/row/row';
import styles from './inclusions-list.module.scss';

interface Feature {
  text: string;
}

export interface InclusionsListProps extends ModuleWrapperProps {
  /** Features that are excluded */
  excludedFeatures: Feature[];
  /** Headline for excluded features */
  excludedText: string;
  /** Features that are included */
  includedFeatures: Feature[];
  /** Headline for included features */
  includedText: string;
}

const InclusionsList = ({
  excludedFeatures,
  excludedText,
  includedFeatures,
  includedText,
  ...rest
}: InclusionsListProps) => {
  return (
    <ModuleWrapper {...rest} className={styles.component}>
      <Container className={styles.container}>
        <Row className={classNames(styles.isIncludedList, styles.row)}>
          <Column width={{ laptop: 3 }}>
            <Typography className={styles.headline} tagStyle="displayMedium">
              {includedText}
            </Typography>
          </Column>

          <Column
            className={styles.column}
            offset={{ laptop: 1 }}
            width={{ laptop: 8 }}
          >
            {includedFeatures.map((feature, featureIndex) => (
              <Typography
                key={featureIndex}
                className={styles.item}
                tagStyle="bodyMedium"
              >
                <Icon
                  className={classNames(styles.icon, styles.isIncluded)}
                  name="CheckMark"
                />

                {feature.text}
              </Typography>
            ))}
          </Column>
        </Row>

        <Row className={classNames(styles.isExcludedList, styles.row)}>
          <Column width={{ laptop: 3 }}>
            <Typography tagStyle="headingSmall">{excludedText}</Typography>
          </Column>

          <Column
            className={styles.column}
            offset={{ laptop: 1 }}
            width={{ laptop: 8 }}
          >
            {excludedFeatures.map((feature, featureIndex) => (
              <Typography
                key={featureIndex}
                className={styles.item}
                tagStyle="bodyMedium"
              >
                <Icon
                  className={classNames(styles.icon, styles.isExcluded)}
                  name="Minus"
                />

                {feature.text}
              </Typography>
            ))}
          </Column>
        </Row>
      </Container>
    </ModuleWrapper>
  );
};

InclusionsList.displayName = 'InclusionsList';

export default InclusionsList;
